import * as c from '../../../../../../constants.jsx';
import GeneticPanelsCardTemplate from "../../../../../../components/CockpitCards/GeneticPanelsCardTemplate.jsx";

export default function DigestCard() {

return(
<>

<GeneticPanelsCardTemplate

  panel_url = {`${c.API_URL}/api/digest`}

  panel_name = { "DIGESTIVE SYSTEM DISORDER PANEL" }
  panel_subtext = {"This panel is based on expert-reviewed gene and disease associations from the ClinGen Evidence Repository."}

/>

</> 
)}